module.exports = __webpack_public_path__ + "static/media/photo_zach.51d1be4f.png";